/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'delete-restore': {
    width: 24,
    height: 24,
    viewBox: '0 0 24 24',
    data: '<path pid="0" d="M14 14h2l-4-4-4 4h2v4h4v-4M6 7h12v12c0 .5-.2 1-.61 1.39-.39.41-.89.61-1.39.61H8c-.5 0-1-.2-1.39-.61C6.2 20 6 19.5 6 19V7m13-3v2H5V4h3.5l1-1h5l1 1H19z"/>'
  }
})
